import React from "react";
import { Outlet } from "react-router-dom";

const UserWrapper: React.FC = () => {
  return <Outlet />;
};

export default UserWrapper;
